import React, {useEffect} from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const SubregionInput = ({name, label, options, load, rules=[], multiple=false, onChange=null, region_id=null, region_ids=null, ...props}) => {

  // load subregions on mount
  useEffect(() => {
    load(1, 250, null, region_id ? {region_id: region_id} : (region_ids ? {region_ids: region_ids} : null));
  }, [load, region_id, region_ids]);

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name}
          label={label}
          rules={rules}
        >
          <Select
            showSearch
            mode={multiple ? "multiple" : null}
            disabled={props.isLoading || props.isSubmitting}
            loading={props.isLoading}
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            onChange={onChange}
          >
            {options.map(x => <Select.Option key={x.value} value={x.value}>{x.label}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default SubregionInput;
